var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 1.51265V4.26634C9.33366 4.63971 9.33366 4.82639 9.40632 4.969C9.47024 5.09444 9.57222 5.19643 9.69766 5.26035C9.84027 5.33301 10.027 5.33301 10.4003 5.33301H13.154M13.3337 6.65849V11.4663C13.3337 12.5864 13.3337 13.1465 13.1157 13.5743C12.9239 13.9506 12.618 14.2566 12.2416 14.4484C11.8138 14.6663 11.2538 14.6663 10.1337 14.6663H5.86699C4.74689 14.6663 4.18683 14.6663 3.75901 14.4484C3.38269 14.2566 3.07673 13.9506 2.88498 13.5743C2.66699 13.1465 2.66699 12.5864 2.66699 11.4663V4.53301C2.66699 3.4129 2.66699 2.85285 2.88498 2.42503C3.07673 2.0487 3.38269 1.74274 3.75901 1.55099C4.18683 1.33301 4.74689 1.33301 5.86699 1.33301H8.00818C8.49736 1.33301 8.74195 1.33301 8.97212 1.38827C9.17619 1.43726 9.37128 1.51807 9.55023 1.62773C9.75206 1.75141 9.92501 1.92436 10.2709 2.27027L12.3964 4.39575C12.7423 4.74165 12.9153 4.9146 13.0389 5.11644C13.1486 5.29538 13.2294 5.49047 13.2784 5.69454C13.3337 5.92472 13.3337 6.16931 13.3337 6.65849Z",
    stroke: "#395BA9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile4);
export default __webpack_public_path__ + "static/media/file4.87eef9c7c2ed6822f31b19ea95b99af8.svg";
export { ForwardRef as ReactComponent };